import { LandingProductCurrencyEnum } from "@dev/ee-api/ee-api-models";
import { getProductMinPrice } from "./getProductMinPrice";

export const isProductPriceValid = (price: number, currency: LandingProductCurrencyEnum): boolean => price >= getProductMinPrice(currency);
